import { useState, useEffect } from "react"
import '../../../css/administration.css'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import DataTable from '../../../components/data-table/DataTable'
import NodeAddEdit from "./NodeAddEdit"

import { NodeAPIService } from "../../../services/apis/NodeAPIService";
import BasicCard from "../../../components/basics/cards/BasicCard";
import { ErrorService } from "../../../services/ErrorService"

function NodeListing() {
    const [currentPage, setCurrentPage] = useState(0) 
    const [showAddEdit, setShowAddEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");

    const initialState = {
        node: {
            nodeId: '',
            nodeCode: '',
            nodeName: '',
            nodeTypeId: '',
            memo: '',
            consolidationLevelId: '',
            defaultCurrencyId: '',
            mappingTypeId: '',
            isDeleted: false,
            lastUpdateDate: ''
        },
        nodes: [],
    };

    const [state, setState] = useState(initialState);

    const initTableConfig = {
        tableData: state.nodes,
        tableColumns: ['Name', 'Node type'],
        tableColumnIds: ['nodeName', 'nodeTypeName'],
        rowId: 'nodeId',
        hasHoverEffect: 'true',
        handleRowClick: (id) => {
            NodeAPIService.getNode(id).then(data => {
                if (data.error) {
                    setError(ErrorService.getErrorMessage(data.error.status))
                }
                var node = {
                    nodeId: data.nodeId,
                    nodeCode: data.nodeCode,
                    nodeName: data.nodeName,
                    nodeTypeId: data.nodeTypeId,
                    memo: data.memo,
                    consolidationLevelId: data.consolidationLevelId,
                    defaultCurrencyId: data.currencyId,
                    mappingTypeId: data.mappingTypeId,
                    isDeleted: data.isDeleted,
                    lastUpdateDate: data.lastUpdateDate
                };
                setState(values => ({ ...values, node: node }));
                setShowAddEdit(true);
            });
        }
    }
    
    const [tableConfig, setTableConfig] = useState(initTableConfig);

    useEffect(() => {
        NodeAPIService.getAll().then(data => {
            setIsLoading(false);
            if (data.error)
                setError(ErrorService.getErrorMessage(data.error.status))
            else {
                setState(values => ({ ...values, nodes: data }))
                setTableConfig(prevState => ({
                    ...prevState,
                    tableData: data
                }));
                setError(false)
            }
        });
    }, []);

    // CONSTANTS
    const NUM_TABLE_ROWS = 5
    

    // EVENT HANDLERS
    const handlePageChange = (page) => {
        setCurrentPage(page - 1)
    }

    const handleCreateNewNode = () => {
        var node = {
            nodeId: '',
            nodeCode: '',
            nodeName: '',
            nodeTypeId: '',
            memo: '',
            consolidationLevelId: '',
            defaultCurrencyId: '',
            mappingTypeId: '',
            isDeleted: false,
            lastUpdateDate: ''
        };
        setState(values => ({ ...values, node: node }));
        setShowAddEdit(true);
    }

    const handleRowClick = (id) => {
        NodeAPIService.getNode(id).then(data =>
        {
            if (data.error) {
                setError(ErrorService.getErrorMessage(data.error.status))
            }
            var node = {
                nodeId: data.nodeId,
                nodeCode: data.nodeCode,
                nodeName: data.nodeName,
                nodeTypeId: data.nodeTypeId,
                memo: data.memo,
                consolidationLevelId: data.consolidationLevelId,
                defaultCurrencyId: data.currencyId,
                mappingTypeId: data.mappingTypeId,
                isDeleted: data.isDeleted,
                lastUpdateDate: data.lastUpdateDate
            };
            setState(values => ({ ...values, node: node }));
            setShowAddEdit(true);
        });
    }

    return (
        <Container fluid className='basic-listing-container'>
                <Row>
                    <Col>
                    <BasicCard cardConfig={{ cardTitle: 'Nodes', cardHeadingElement: 'h4' }}>
                        {isLoading ? <p>Loading data ...</p> : ""}
                        {error ? <p style={{ color: 'red' }}>{error}</p> : "" }
                        {state.nodes?.length > 0 ?
                                <div className='listing-table-wrapper'>
                                <DataTable tableConfig={tableConfig} state={state} setAddEdit={setShowAddEdit} />
                                    <Button variant='primary' onClick={handleCreateNewNode} className='listing-add-button'>+</Button>
                                </div>
                            : ""
                        }
                        </BasicCard>
                    </Col>
                    {showAddEdit && (
                        <Col>
                        <NodeAddEdit setShowAddEdit={setShowAddEdit} state={state} setState={setState}/>
                        </Col>
                    )}
                </Row>
        </Container>
    )
}

export default NodeListing